export default __webpack_public_path__ + "static/media/KristineHonomichl.c689255c.jpg";